<template>
  <div class="principal-body">
    <div style="display: flex;align-items: center;">
      <v-icon style="margin-right: 5px" @click="goBack">
        mdi-chevron-left
      </v-icon>
      <Avatar :address="invoiceId" style="margin-top: 2%; margin-right: 5px" />
      {{ $t('BrowseScroll.head') }}
      <strong v-if="invoiceNumber" style="padding-left: 3px;"> {{ invoiceInformation.number }} </strong>
      <strong v-else style="padding-left: 3px;"> {{ $t('BrowseScroll.undefined') }} </strong>
    </div>
    <div :style="{position: 'absolute', 'overflow-y': 'auto', right: 0, left: 0,background:'white','overflow-x': 'hidden'}">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow>
        <v-tab
          v-for="item in items"
          :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="Invoice">
          <v-card color="basil" flat>
            <InvoiceView />
          </v-card>
        </v-tab-item>

        <v-tab-item
          key="Data"
        >
          <v-card
            color="basil"
            flat
          >
            <InvoiceInformation :invoice-id="invoiceId" />
          </v-card>
        </v-tab-item>

        <v-tab-item
          key="Byppays"
        >
          <v-card
            color="basil"
            flat
          >
            <ByppayList />
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <div v-if="showAlert" style="width: 200px;text-align: center;margin:auto;" @click="missingInformation">
        <v-alert
          outlined
          type="error"
          style="font-size: 10px;padding: 5px;text-align: center;margin-top: 10px;cursor: pointer"
        >
          {{ $t('Missing Data') }}
        </v-alert>
      </div>
      <v-dialog
        v-model="dialogMissingInv"
        width="500"
      >
        <v-card>
          <InvoiceMissingInformation v-if="!loading && currentInvoice" :invoice="currentInvoice" :file="files[0].originalName" :forward="true" @back="closeModalInvoice" @update="closeModalInvoice" />
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>

import InvoiceMissingInformation from "../components/InvoiceMissingInformation";
import InvoiceView from "components/InvoiceView";
import ByppayList from "components/ByppayList";
import InvoiceInformation from "components/invoiceInformation";
import ApiRepository from "../repositories/ApiRepository";
import Avatar from "../components/Avatar";
export default {
    name: "BrowseScroll",
    components: {   Avatar, InvoiceMissingInformation,  InvoiceView, ByppayList, InvoiceInformation},
    props: {
    },
    data () {
        return {
            invoiceId: null,
            invoiceInformation: null,
            invoiceNumber: null,
            tab: null,
            items: ['Invoice', this.$t('BrowseScroll.DATA'), 'Byppays'],
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            showAlert: false,
            dialogMissingInv: false,
            loading: false,
            files: null,
            currentInvoice: null,
            data: [],
            dialog: false,
            chatInformation: null,
        };
    },
    computed: {
        color () {
            return (this.$vuetify.theme.dark) ? this.$vuetify.theme.themes.dark.background : this.$vuetify.theme.themes.light.background;
        },
    },
    watch: {
        $route () {
            this.invoiceId = this.$route.query.invoiceId;
            this.fetch();
        }
    },
    created () {
        this.tab = this.$route.query.tab ? parseInt(this.$route.query.tab) : 0;
        this.invoiceId = this.$route.query.invoiceId;
        this.chatInformation = this.$route.query.chatId;
        console.log(this.chatInformation);
        this.fetch();
    },
    mounted () {
        this.$root.$on('changeTabEvent', (tab) => {
            this.tab = tab;
        });
    },
    methods: {
        //Fetch & MOD
        //MODALS
        fetch () {
            ApiRepository.getInvoiceById(this.invoiceId).then((res) => {
                this.invoiceInformation = res.data.invoice;
                this.invoiceNumber = this.invoiceInformation.number;
            });
        },
        closeModalInvoice () {
            this.dialogMissingInv = false;
        },
        openModals () {
            if (!this.bypayDisabled || !this.forwardDisabled) {
                this.compensate();
            }
        },
        goBack () {
            if (this.chatInformation !== undefined)
                this.$router.push({name: 'AllInvoicesChat', query: {chatId: this.chatInformation}, replace: true});
            else
                this.$router.push({name: 'InvoiceChats', replace: true});
        },
        askLogin () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Login'),
                message: this.$t('In order to do this option you need to login, Do you want to login?'),
                oneButton: true,
                yes: () => {
                    this.$router.push({name: 'Login', replace: true});
                }
            });
        },
    },

};
</script>

<style scoped>

</style>

<style>
  .custom-switch label {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1.52px;
  }

  .centered-input input {
    text-align: center
  }

  .action-buttons div {
    margin-right: 5px;
    float: left;
  }

  .bottom-card .v-text-field input{
    padding: 0px !important;
  }
</style>
